module.exports = __webpack_public_path__ + "files/bb478bdba00fabaca1526dc179d16b56.png";